// @ts-nocheck
document.addEventListener("alpine:init", () => {
    Alpine.data("ctrCountdown", function ({timezone, timeFormat, endTimeFixed, endTimeDaily, enableCountdown}) {
        return {
            enableCountdown: enableCountdown,
            timezone: timezone,
            timeFormat: timeFormat,
            endTimeDaily: endTimeDaily,
            endTimeFixed: endTimeFixed ? new Date(endTimeFixed) : null,
            endTimeFixedTest: endTimeFixed,
            remaining: 0,
            SECOND_IN_MS: 1000,
            HOUR_IN_SECONDS: 3600,
            DAY_IN_SECONDS: 86400,

            getTime() {
                return {
                    days: this.format(this.days().value),
                    hours: this.format(this.hours().value),
                    minutes: this.format(this.minutes().value),
                    seconds: this.format(this.seconds().value),
                };
            },

            updateCountdown() {
                this.setRemaining();
            },

            setRemaining() {
                const now = new Date().getTime();
                if (this.timeFormat === 'fixed') {
                    this.remaining = parseInt((this.endTimeFixed.getTime() - now) / this.SECOND_IN_MS);
                }
                if (this.timeFormat === 'daily') {
                    const [hours, minutes, seconds] = this.endTimeDaily.split(':').map(Number);
                    const endDateDaily = new Date();
                    endDateDaily.setHours(hours, minutes, seconds);
                    this.remaining = parseInt((endDateDaily.getTime() - now) / this.SECOND_IN_MS);
                    if (this.remaining <= 0) {
                        endDateDaily.setDate(endDateDaily.getDate() + 1);
                        this.remaining = parseInt((endDateDaily.getTime() - now) / this.SECOND_IN_MS);
                    }
                }
            },

            startCountdown() {
                this.setRemaining();

                if (this.remaining > 0) {
                    const intervalId = setInterval(() => {
                        this.updateCountdown();

                        if (this.remaining <= 0 && intervalId) {
                            clearInterval(intervalId);
                        }
                    }, this.SECOND_IN_MS);
                }

                
            },

            init() {
                if (!this.enableCountdown) { return; };
                // const storeTimezoneFormatter = new Intl.DateTimeFormat('en-US', {
                //     timeZone: this.timezone,
                //     year: 'numeric',
                //     month: '2-digit',
                //     day: '2-digit',
                //     hour: '2-digit',
                //     minute: '2-digit',
                //     second: '2-digit'
                // });
                // const parts = storeTimezoneFormatter.formatToParts(new Date(this.endTimeFixedTest.replace(' ', 'T')));
                // const storeTime = new Date(parts.map(part => part.value).join(''));

                // console.log('storeTime', storeTime);
                this.startCountdown();
            },

            days() {
                if (this.remaining <= 0) {
                    return {
                        value: 0,
                        remaining: 0
                    };
                }
                return {
                    value: this.remaining / this.DAY_IN_SECONDS,
                    remaining: this.remaining % this.DAY_IN_SECONDS
                };
            },

            hours() {
                if (this.remaining <= 0) {
                    return {
                        value: 0,
                        remaining: 0
                    };
                }
                return {
                    value: this.days().remaining / this.HOUR_IN_SECONDS,
                    remaining: this.days().remaining % this.HOUR_IN_SECONDS
                };
            },

            minutes() {
                if (this.remaining <= 0) {
                    return {
                        value: 0,
                        remaining: 0
                    };
                }
                return {
                    value: this.hours().remaining / 60,
                    remaining: this.hours().remaining % 60
                };
            },

            seconds() {
                if (this.remaining <= 0) {
                    return {
                        value: 0,
                    };
                }
                return {
                    value: this.minutes().remaining,
                };
            },

            format(value) {
                return ("0" + parseInt(value)).slice(-2)
            },

            time() {
                return {
                    days: this.format(this.days().value),
                    hours: this.format(this.hours().value),
                    minutes: this.format(this.minutes().value),
                    seconds: this.format(this.seconds().value),
                };
            },
        };
    });
});